import { render, staticRenderFns } from "./CsTarifariosIndex.vue?vue&type=template&id=0757120e"
import script from "./CsTarifariosIndex.vue?vue&type=script&lang=js"
export * from "./CsTarifariosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports